define(function(require, exports, module){
    var tool = require('tool'),
        $ = require('jquery');

    return tool.init($);
});